import type { RouteObject } from 'react-router';
import { WorkflowPage } from '../ops/workflows/WorkflowPage';
import { PollMessagePage } from './PollMessagePage';
import { ReconciliationIssuePage } from './ReconciliationIssuePage';
import { RegistryDetailPage } from './RegistryDetailPage';
import { TldDetailPage } from './TldDetailPage';

/** Detail routes (paths without a leading slash). */
export const REGISTRY_ROUTES: RouteObject[] = [
  { path: 'ops/workflows/:id', element: <WorkflowPage /> },
  { path: 'registry/registries/:code', element: <RegistryDetailPage /> },
  { path: 'registry/tlds/:id', element: <TldDetailPage /> },
  { path: 'registry/poll/:id', element: <PollMessagePage /> },
  { path: 'registry/reconciliation/:id', element: <ReconciliationIssuePage /> },
];
